import React, { Suspense } from 'react';

const Component = React.lazy(() => import('./IpotekaBrokersReport'));

function Loader() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Component />
    </Suspense>
  )
}

export default Loader;